import React from "react";

const Divider = ({ direction = "horizontal", className = "" }) => {
  const isVertical = direction === "vertical";

  return (
    <div
      className={`si-divider ${
        isVertical ? "si-divider--vertical" : "si-divider--horizontal"
      } ${className}`}
      style={
        isVertical
          ? {
              alignSelf: "stretch",
              flexShrink: 0,
              // Temporary debug - remove after confirming it works
              // backgroundColor: "red",
              // width: "3px",
            }
          : {}
      }
      role="separator"
      aria-orientation={isVertical ? "vertical" : "horizontal"}
    />
  );
};

export { Divider };
